<app-recipes-translation-section
  [sectionOptions]="{
    title: 'RECIPE_TRANSLATION.SECTIONS.TIPS.HEADER',
    icon: 'ic_comment',
    lang: !!sourceTipsControl.getRawValue() ? lang : undefined
  }"
>
  <app-recipes-translation-fields-container *ngIf="!!sourceTipsControl.getRawValue(); else noTip">
    <app-recipes-translation-input-fields
      [fieldsOptions]="{
        sourceControl: { left: sourceTipsControl },
        targetControl: { left: targetTipsControl },
        size: 'sm'
      }"
    >
    </app-recipes-translation-input-fields>
  </app-recipes-translation-fields-container>

  <ng-template #noTip>
    <p translate>RECIPE_TRANSLATION.SECTIONS.TIPS.NO_TIP</p>
  </ng-template>
</app-recipes-translation-section>
